import { useRequest } from 'ahooks'
import { Carousel, Flex } from 'antd'
import { createStyles } from 'antd-style'
import { chunk } from 'lodash'

import { queryBrandListApi } from '@eastcoal/api/content/brandMall/queryBrandList'

import { PagePosition } from '@eastcoal/shared/enums/PagePosition'

import { BrandCarouselProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  container: {
    padding: token.paddingMD
  },
  img: {
    borderRadius: token.borderRadius
  }
}))

const getJustify = (justify: BrandCarouselProps['justify'], index: number) => {
  if (Array.isArray(justify)) {
    return justify[index] || justify[0]
  }
  return justify
}

export const BrandCarousel = ({
  pageName,
  prePageCount = 9,
  classNames: externalClassNames,
  styles: externalStyles,
  /* ************************************************************************** */
  /*                                  FlexProps                                 */
  /* ************************************************************************** */
  gap,
  wrap = true,
  justify = 'space-between',
  align
}: BrandCarouselProps) => {
  const { data } = useRequest(
    () =>
      queryBrandListApi(
        { pageName, pagePosition: PagePosition.BOTTOM },
        { silence: true }
      ),
    {
      manual: false,
      retryCount: 3,
      retryInterval: 200
    }
  )

  const { cx, styles, theme } = useStyles()

  const brandNodes = data
    ?.filter(item => !!item.accessUrl)
    .map(({ id, accessUrl, navigateUrl }) => (
      <a key={id} href={navigateUrl} rel='noreferrer' target='_blank'>
        <img
          alt='banner'
          className={cx(styles.img, externalClassNames?.img)}
          src={accessUrl}
          style={{
            height: 64,
            ...externalStyles?.img
          }}
        />
      </a>
    ))

  if (!brandNodes) {
    return null
  }

  // 最外层的 div 是为了防止样式被 Carousel 影响
  return (
    <Carousel
      draggable
      arrows={false}
      autoplaySpeed={5000}
      className={externalClassNames?.carousel}
      dots={false}
      style={externalStyles?.carousel}
    >
      {chunk(brandNodes, prePageCount).map((items, index) => (
        <div key={index}>
          <Flex
            align={align}
            className={cx(styles.container, externalClassNames?.container)}
            gap={gap ?? theme.padding}
            wrap={wrap}
            style={{
              ...externalStyles?.container,
              justifyContent:
                items.length >= prePageCount
                  ? getJustify(justify, 0)
                  : getJustify(justify, 1)
            }}
          >
            {items}
          </Flex>
        </div>
      ))}
    </Carousel>
  )
}
